module.exports = __webpack_public_path__ + "static/media/slide-1.b945aa68.png";